import ModalView from '../../../../scripts/utils/modal-view.js';
import Urls from '../urls.js';

export default class PopupContentView extends ModalView {
	constructor({ el, modal_selector, navigation, isOpened, isClosed }) {
		super({ el, modal_selector, navigation });
		this.template_url = Urls.Templates.app;
		this.isOpened = isOpened;
		this.isClosed = isClosed;
		this.render();
	}
	after_render() {
		this.init_modal();
		this.init_popup_events();
		this.open();
	}
}